// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__RG4o2","label":"Completed_label__2Ytyy"};